// Jira issue [PG-1496]: 포컷랭킹 운영자 계정의 프로필은 방문이 불가능 하도록 처리
export const APR_USER_IDS = [
  '1cc848ca-dd3a-4e9d-b177-24647d4722b3', // production aprkakao@apr-in.com
];
